import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BadgeCheck } from 'lucide-react';
interface Buyer {
  name: string;
  location: string;
}
const buyers: Buyer[] = [{
  name: 'James M.',
  location: 'Chicago, USA'
}, {
  name: 'Sophie L.',
  location: 'Lyon, France'
}, {
  name: 'Marco R.',
  location: 'Milan, Italy'
}, {
  name: 'Emma T.',
  location: 'Manchester, UK'
}, {
  name: 'Lucas P.',
  location: 'São Paulo, Brazil'
}, {
  name: 'Hannah K.',
  location: 'Berlin, Germany'
}, {
  name: 'David S.',
  location: 'Toronto, Canada'
}, {
  name: 'Yuki N.',
  location: 'Osaka, Japan'
}, {
  name: 'Carlos G.',
  location: 'Madrid, Spain'
}, {
  name: 'Olivia W.',
  location: 'Sydney, Australia'
}, {
  name: 'Noah B.',
  location: 'Amsterdam, Netherlands'
}, {
  name: 'Mia F.',
  location: 'Stockholm, Sweden'
}, {
  name: 'Diego A.',
  location: 'Buenos Aires, Argentina'
}, {
  name: 'Chloe D.',
  location: 'Auckland, New Zealand'
}, {
  name: 'Ethan H.',
  location: 'Austin, USA'
}, {
  name: 'Anna V.',
  location: 'Warsaw, Poland'
}];
const minutesAgoOptions = [2, 4, 7, 9, 12, 15, 18, 23];
export const VerifiedPurchasePopup = () => {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState<{
    buyer: Buyer;
    minutes: number;
  } | null>(null);
  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout>;
    let cycleTimer: ReturnType<typeof setTimeout>;
    const showPopup = () => {
      const buyer = buyers[Math.floor(Math.random() * buyers.length)];
      const minutes = minutesAgoOptions[Math.floor(Math.random() * minutesAgoOptions.length)];
      setCurrent({
        buyer,
        minutes
      });
      setVisible(true);
      // Hide after ~5 seconds
      hideTimer = setTimeout(() => setVisible(false), 5000);
      // Schedule next popup in 40-50 seconds
      const nextDelay = 40000 + Math.random() * 10000;
      cycleTimer = setTimeout(showPopup, nextDelay);
    };
    // First popup after an initial short delay
    const initialTimer = setTimeout(showPopup, 8000);
    return () => {
      clearTimeout(initialTimer);
      clearTimeout(hideTimer);
      clearTimeout(cycleTimer);
    };
  }, []);
  return <div className="fixed bottom-4 left-4 z-50 pointer-events-none" data-id="element-226" data-mp="1ace0feg4du9l">
      <AnimatePresence data-id="element-227" data-mp="1ae76ariwsagj">
        {visible && current && <motion.div initial={{
        opacity: 0,
        y: 30,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} role="status" aria-live="polite" className="pointer-events-auto flex items-center gap-3 bg-navy-800 border border-vbgold/30 rounded-xl shadow-2xl p-3 pr-4 max-w-[300px]" data-id="element-228" data-mp="1ed7p4a1dzd3j">
            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-vbgold/15 flex items-center justify-center" data-id="element-229" data-mp="ee5qrq69f8mn">
              <BadgeCheck className="w-6 h-6 text-vbgold" data-id="element-230" data-mp="9fm5zt3ek2vv" />
            </div>
            <div className="min-w-0" data-id="element-231" data-mp="5dhep10ffice">
              <div className="flex items-center gap-1.5" data-id="element-232" data-mp="5eiqj7p9o8v6">
                <p className="text-sm font-bold text-white truncate" data-id="element-233" data-mp="ee8vecmh83d">
                  {current.buyer.name}
                </p>
                <span className="flex-shrink-0 text-[9px] font-bold uppercase tracking-wider text-green-400 bg-green-500/15 border border-green-500/30 px-1.5 py-0.5 rounded" data-id="element-234" data-mp="3rjw54f28htf7">
                  Verified
                </span>
              </div>
              <p className="text-xs text-gray-300 leading-snug" data-id="element-235" data-mp="1psjbim5pv7yg">
                Just got{' '}
                <span className="text-vbgold font-semibold" data-id="element-236" data-mp="1kv110rc1wkoc">
                  Volleyball Ready Pro
                </span>
              </p>
              <p className="text-[11px] text-gray-500 mt-0.5" data-id="element-237" data-mp="1xtqnng5nzrwg">
                {current.buyer.location} · {current.minutes} min ago
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
};